import { trackEvent } from '~/utils/tracking'
import { createOptimizedContentfulImage } from '~/libs/contentful/helpers'
import { TypeArticle, TypeBlogCategorySkeleton } from '~/types/contentful'
import { Asset, AssetFile, Entry } from 'contentful'

export type ArticleAsidePreviewProps = {
  data: TypeArticle<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const ArticleAsidePreview = ({ data }: ArticleAsidePreviewProps) => {
  const { category } = data.fields

  const categoryEntry = category as Entry<
    TypeBlogCategorySkeleton,
    'WITHOUT_UNRESOLVABLE_LINKS',
    string
  >
  const ctaBanner = categoryEntry?.fields?.ctaBanner as Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>

  return (
    <a
      href={categoryEntry.fields?.ctaBannerLink}
      onClick={() =>
        trackEvent('article_banner', {
          blog_id: categoryEntry?.fields?.slug,
          banner_type: categoryEntry?.fields?.name,
        })
      }
      className="flex flex-col max-lg:flex-row rounded-3xl pr-6"
    >
      <img
        width={ctaBanner?.fields?.file?.details?.image?.width}
        src={createOptimizedContentfulImage({ file: ctaBanner?.fields?.file as AssetFile })}
        alt="Article aside preview banner"
        className="max-w-full"
      />
    </a>
  )
}
